import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { store } from '../../../../store';

class PaymentGate extends Component {
  render() {
    if(store.getState().pricing.currentPlan.plan === 'free') {
      return (
        <div className={'payment-gate ' + this.props.className}>
          {this.props.children}

          <Link to={ {pathname: '/profile/plans'} } className="btn btn-primary" >View Plans</Link>
        </div>
      );
    } else {
      return (
        <div></div>
      )
    }
  }
}

export default PaymentGate;
